import {Component} from '@angular/core';

import { SaveMoneyEnergyBillsComponent } from '../save-money-energy-bills/save-money-energy-bills.component';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-pagenotfound',
  standalone: true,
  imports: [SaveMoneyEnergyBillsComponent],
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent {
  maintenanceMode = environment.maintenanceMode;
}
